import { mockData } from "./Mock";
import { SignatureAudit } from "../../models/SignatureAudit";

const imageMock = "https://pub-img-wfile.yuanling.com/3/33/45/6/49/5eafce2266281a71a0f693d1483cf67851d1181f2de225f97a00a212.png";

const mockCandidates: SignatureAudit[] = [
    {
        id: "B1001",
        submitterId: "B1001",
        submitterType: 1,
        submitterPhone: "13800138001",
        nickname: "设计大师",
        realName: "张三",
        signatureUrl: imageMock,
        lastRefuseReason: "",
        submitTime: "2024-03-20 14:30:00",
        updateTime: "2024-03-20 14:30:00"
    },
    {
        id: "B1002",
        submitterId: "B1002",
        submitterType: 0,
        submitterPhone: "13800138002",
        nickname: "买家小王",
        realName: "王五",
        signatureUrl: imageMock,
        lastRefuseReason: "",
        submitTime: "2024-03-20 15:00:00",
        updateTime: "2024-03-20 15:00:00"
    },
    {
        id: "B1003",
        submitterId: "B1003",
        submitterType: 1,
        submitterPhone: "13800138003",
        nickname: "创意工作室",
        realName: "李四",
        signatureUrl: imageMock,
        lastRefuseReason: "",
        submitTime: "2024-03-20 16:00:00",
        updateTime: "2024-03-20 16:00:00"
    }
];

const mockProcessed: SignatureAudit[] = [
    {
        id: "B2001",
        submitterId: "B2001",
        submitterType: 1,
        submitterPhone: "13900139001",
        nickname: "代码工匠",
        realName: "赵六",
        signatureUrl: imageMock,
        lastRefuseReason: "签名不清晰，请重新提交",
        submitTime: "2024-03-19 10:00:00",
        updateTime: "2024-03-19 11:00:00"
    },
    {
        id: "B2002",
        submitterId: "B2002",
        submitterType: 0,
        submitterPhone: "13900139002",
        nickname: "买家小李",
        realName: "李七",
        signatureUrl: imageMock,
        lastRefuseReason: "",
        submitTime: "2024-03-18 09:00:00",
        updateTime: "2024-03-18 09:30:00"
    }
];

mockData.set("signature_audit_candidates", mockCandidates);
mockData.set("signature_audit_processed", mockProcessed);

